<div class="page-layout">
  <app-toast></app-toast>
  <app-sidebar></app-sidebar>

  <div class="main-area">
    <app-navbar
      pageTitle="Upload Documents"
      pageSubtitle="Upload documents from your computer to create a new batch (up to 1GB total)."
    ></app-navbar>

    <div class="content">
      <div class="upload-header-row">
        <button class="back-btn" (click)="goBack()">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="15 18 9 12 15 6"></polyline>
          </svg>
        </button>
      </div>

      <div class="panel">
        <div class="panel-head">
          <div>
            <p class="panel-title">Batch details</p>
            <p class="panel-desc">Name this batch so you can find it in Manage Batches.</p>
          </div>
        </div>

        <div class="field-row">
          <label class="field">
            <span class="field-label">Name<span class="required">*</span></span>
            <input class="ff-input" type="text" placeholder="e.g. Q3 contracts" [ngModel]="name()" (ngModelChange)="name.set($event)" [disabled]="isUploading()" />
          </label>
          <label class="field">
            <span class="field-label">Description</span>
            <input class="ff-input" type="text" placeholder="Optional" [ngModel]="description()" (ngModelChange)="description.set($event)" [disabled]="isUploading()" />
          </label>
        </div>
      </div>

      <div class="panel">
        <div class="panel-head">
          <div>
            <p class="panel-title">Upload documents</p>
            <p class="panel-desc">Select the files to ingest. 1GB total per batch.</p>
          </div>
        </div>

        <div class="dropzone" *ngIf="!isUploading()">
          <div class="dz-icon">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 16V4M12 4l-4 4M12 4l4 4"/><path d="M4 16v3a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-3"/></svg>
          </div>
          <div class="dz-title">Choose documents to upload</div>
          <div class="dz-sub">PDF, DOCX, XLSX and more &middot; select multiple, or click again to add more</div>
          <label class="btn primary">
            {{ selectedFiles().length > 0 ? 'Add More Files' : 'Choose Files' }}
            <input type="file" multiple hidden (change)="onFilesSelected($event)" />
          </label>
        </div>

        <div class="staged-files" *ngIf="!isUploading() && selectedFiles().length > 0">
          <div class="staged-file" *ngFor="let file of selectedFiles(); let i = index">
            <div class="file-icon small">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/></svg>
            </div>
            <div class="file-info">
              <div class="file-name">{{ file.name }}</div>
              <div class="file-meta plain">{{ formatBytes(file.size) }}</div>
            </div>
            <button type="button" class="icon-btn danger" title="Remove" (click)="removeSelectedFile(i)">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
            </button>
          </div>

          <div class="staged-files-footer">
            <span class="total-size" [class.over-limit]="isOverLimit()">{{ formatBytes(totalBytes()) }} / 1 GB</span>
            <button type="button" class="btn ghost small" (click)="clearSelectedFiles()">Clear</button>
            <button type="button" class="btn primary small" [disabled]="!canSubmit()" (click)="submit()">
              Upload {{ selectedFiles().length }} File{{ selectedFiles().length === 1 ? '' : 's' }}
            </button>
          </div>

          <div class="note note-error" *ngIf="isOverLimit()">
            These files total {{ formatBytes(totalBytes()) }}, which is over the 1GB limit for one batch. Remove some files to continue.
          </div>
        </div>

        <div class="proc-row" *ngIf="isUploading()">
          <div class="proc-ring"></div>
          <div>
            <div class="proc-text">Uploading {{ selectedFiles().length }} document(s)…</div>
            <div class="proc-sub">This can take a moment, especially for larger files. Please don't navigate away.</div>
          </div>
        </div>
      </div>

      <div class="note">
        Uploading creates the batch as a draft — nothing is processed yet. Once it's created, start ingestion from <strong>Manage Batches</strong>, the same way as any other batch.
      </div>
    </div>
  </div>
</div>
